import React from "react";
import { I18n } from "aws-amplify";

import SignIn from "aws-amplify-react/lib/Auth/SignIn";
import SignUp from "aws-amplify-react/lib/Auth/SignUp";
import ForgotPassword from "aws-amplify-react/lib/Auth/ForgotPassword";
import { FederatedButtons } from "aws-amplify-react/lib/Auth/FederatedSignIn";
import { FormSection, FormField, SectionHeader, SectionBody, SectionFooter, Button, Link, Hint, Input, InputLabel, SectionFooterPrimaryContent, SectionFooterSecondaryContent } from "aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React";

import { auth } from "aws-amplify-react/lib/Amplify-UI/data-test-attributes";

export default class CustomSignIn extends SignIn {
  // Extend Amplify's SignIn to preserve built-in auth behavior while
  // controlling the visual ordering of Sign In / Create account / Reset password.
  showComponent(theme) {
    const { authState, hide = [], federated, onStateChange, onAuthEvent, override = [] } = this.props;
    const overrideList = Array.isArray(override) ? override : [override];

    const hasSignUpOverride = overrideList.includes("SignUp") || overrideList.includes("signUp");
    const hasForgotPasswordOverride = overrideList.includes("ForgotPassword") || overrideList.includes("forgotPassword");

    const hideSignUp = !hasSignUpOverride && hide.some((component) => component === SignUp);
    const hideForgotPassword = !hasForgotPasswordOverride && hide.some((component) => component === ForgotPassword);

    return (
      <FormSection theme={theme} data-test={auth.signIn.section}>
        <SectionHeader theme={theme} data-test={auth.signIn.headerSection}>
          {I18n.get("Sign in to your account")}
        </SectionHeader>
        <FederatedButtons federated={federated} theme={theme} authState={authState} onStateChange={onStateChange} onAuthEvent={onAuthEvent} />
        <form onSubmit={this.signIn}>
          <SectionBody theme={theme} data-test={auth.signIn.bodySection}>
            {this.renderUsernameField(theme)}
            <FormField theme={theme}>
              <InputLabel theme={theme}>{I18n.get("Password")} *</InputLabel>
              <Input placeholder={I18n.get("Enter your password")} theme={theme} key="password" type="password" name="password" onChange={this.handleInputChange} data-test={auth.signIn.passwordInput} />
            </FormField>
          </SectionBody>

          {/* Keep primary action and sign-up CTA grouped together. */}
          <SectionFooter theme={theme} data-test={auth.signIn.footerSection} className="auth-screen__sign-in-footer">
            <SectionFooterPrimaryContent theme={theme}>
              <Button theme={theme} type="submit" disabled={this.state.loading} data-test={auth.signIn.signInButton}>
                {I18n.get("Sign In")}
              </Button>
            </SectionFooterPrimaryContent>

            {!hideSignUp && (
              <SectionFooterSecondaryContent theme={theme}>
                {I18n.get("No account? ")}
                <Link theme={theme} onClick={() => this.changeState("signUp")} data-test={auth.signIn.createAccountLink}>
                  {I18n.get("Create account")}
                </Link>
              </SectionFooterSecondaryContent>
            )}
          </SectionFooter>

          {/* Forgot-password row intentionally rendered below footer actions. */}
          {!hideForgotPassword && (
            <Hint theme={theme} className="auth-screen__forgot-row">
              {I18n.get("Forgot your password? ")}
              <Link theme={theme} onClick={() => this.changeState("forgotPassword")} data-test={auth.signIn.forgotPasswordLink}>
                {I18n.get("Reset password")}
              </Link>
            </Hint>
          )}
        </form>
      </FormSection>
    );
  }
}
